import createReducer from './createReducer';
import { ReportActions } from '../actions'
import { REPORT } from '../constants/actions';


export const report = createReducer({}, {
  [REPORT.SET_INVENTORY_REPORT](state = {}, action: ReturnType<typeof ReportActions.setInventoryReport>) {
    return { ...state, inventoryReport: action.payload }
  },
});